<template lang='pug'>
    section.area-monitorada
        BaseHeader(
            titulo='Área monitorada',
            voltarPara
        )

        .view-container-base-header
            MonitoramentoDashboard(
                v-if='abaSelecionadaAreaMonitorada === "monitoramento" && dadosAreaMonitorada',
                :dadosAreaMonitorada='dadosAreaMonitorada'
            )
            historico(
                v-if='abaSelecionadaAreaMonitorada === "historico"',
                :dadosAreaMonitorada='dadosAreaMonitorada'
            )
            analise-socio-ambiental(
                v-if='abaSelecionadaAreaMonitorada === "analiseSocioAmbiental"',
                :dadosAreaMonitorada='dadosAreaMonitorada'
            )
</template>

<script>
import Store from '@/store';
import AbaAreaMonitorada from '@/components/areamonitorada/AbaAreaMonitorada';
import AreasMonitoradasService from '@/services/AreasMonitoradasService';
import MonitoramentoDashboard from '@/views/monitoramento/MonitoramentoDashboard';
import Historico from '@/components/areamonitorada/Historico';
import AnaliseSocioAmbiental from '@/components/areamonitorada/AnaliseSocioAmbiental';
import { mapGetters } from 'vuex';
import ItemDadosGerais from '@/components/quantitativos/ItemInformacoes';
import BaseHeader from '@/components/BaseHeader.vue';

export default {
    name: 'AreaMonitorada',
    components: {
        BaseHeader,
        ItemDadosGerais,
        AbaAreaMonitorada,
        MonitoramentoDashboard,
        Historico,
        AnaliseSocioAmbiental
    },
    computed: {
        ...mapGetters(['abaSelecionadaAreaMonitorada'])
    },

    data() {
        return {
            gruposAlerta: [],
            dadosAreaMonitorada: null
        };
    },
    methods: {
        findDadosAreaMonitorada() {
            AreasMonitoradasService.findById(
                this.$route.params.idAreaMonitorada
            )
                .then(({ data }) => {
                    this.dadosAreaMonitorada = data;
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar os dados da área monitorada'
                    });
                })
                .finally();
        }
    },

    mounted() {
        this.findDadosAreaMonitorada();
        Store.commit('SET_ABA_AREA_MONITORADA', 'monitoramento');
    },

    destroyed() {
        Store.commit('SET_ABA_AREA_MONITORADA', null);
    }
};
</script>

<style scoped lang='scss'>
.area-monitorada {
    width: 100%;
    height: 100%;
}
</style>
